<template>
    <div class="px-3 py-2" style="direction:rtl">
        <v-form
            ref="form"
            lazy-validation
        >
            <b-sidebar backdrop id="support_terms" width="50rem" style="direction:ltr" right :title="lang.support_terms_title" shadow >
            <v-divider></v-divider>
                <v-row class="m-2">
                    <v-col cols="12">
                        <v-textarea
                            v-model="description"
                            :label="lang.support_terms_label"
                            :rules="textrule"
                        ></v-textarea>
                    </v-col>
                    
                    <v-col cols="3">
                        <b-button type="button" @click="addTerms()" class="btn btn-success btn-sm">{{ lang.add }}</b-button>
                    </v-col>
                </v-row>
            </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
export default{
    data() {
        return {
            textrule:[
                  v => !!v || this.lang.field_required,
            ],
            description: '',
        }
    },
    methods: {
        addTerms(){
            if(!this.$refs.form.validate()){
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addTerms");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crmid]",this.$route.params.id);
            post.append("data[description]",this.description);
            post.append("data[type]",'support');
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                this.getTerms()
            })
        },
        getTerms(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
          post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","getTerms");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("data[crmid]",this.$route.params.id);
            post.append("data[type]",'support');
            axios.post(
                this.$store.state.SAMCOTEC.r_path , post
            ).then((response) => {
                this.description = response.data.results.data;
            })
        }
    },
    created() {
        this.getTerms();
       
    },
}
</script>